import { call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../../helpers'
import { reduxFetch } from '../../http/reduxFetch'
import ReservationEndpoint from '../../persistence/ReservationEndpoint'

const confirmation = { ...defineTypes('CONFIRMATION_TYPES') }

export const initialState = {
  customer: {},
  started: false,
  loading: false,
  loaded: false
}

export const actions = {
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case confirmation.REQUEST:
      return { ...state, started: true, loading: true }
    case confirmation.FAILURE:
      return { ...state, loading: false }
    case confirmation.SUCCESS:
      return { ...state, order: action.order, loading: false, started: false, step: 2 }
    default:
      return state
  }
}

export const selectors = {
  confirmation_store: (store) => {
    return store
  }
}

export function * confirmationSaga () {
  try {
    yield call(reduxFetch, ReservationEndpoint.create())
    yield put({ type: confirmation.SUCCESS})
  } catch (error) {
    yield put({ type: confirmation.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest(confirmation.REQUEST, confirmationSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/reservation/confirmation.js